import { FormikContextType, useFormikContext } from 'formik'
import { Dispatch, SetStateAction } from 'react'
import styled, { css } from 'styled-components'

import CMYK from 'shared/entities/CMYK'
import { ColorCMYK } from 'shared/types/global'

import ColorsSet from '../ColorsSet'
import { SecondLevelPanels } from '../FrameControls'

const DEFAULT_COLOR = { c: 0, m: 0, y: 0, k: 100 }

const Color = styled.div<{ value?: string; isActive?: boolean }>`
  background-color: ${({ value }) => value};
  border-radius: 8px;
  cursor: pointer;

  ${({ isActive, theme, value }) =>
    isActive &&
    css`
      box-shadow: 0px 0px 0px 2px ${theme.color.base.c0},
        0px 0px 0px 4px ${value};
    `}
`

type FrameColorsProps = {
  labelId: string
  onClick: Dispatch<SetStateAction<SecondLevelPanels | null>>
}

const FrameColors: React.FC<FrameColorsProps> = ({
  onClick,
  labelId
}): JSX.Element => {
  const {
    values: formValues,
    setFieldValue
  }: FormikContextType<any> = useFormikContext()

  const currentColor = new CMYK(
    formValues?.color ?? formValues?.palletteColor ?? DEFAULT_COLOR
  )

  return (
    <ColorsSet
      labelId={labelId}
      currentColor={currentColor}
      onCurrentClick={() => onClick(SecondLevelPanels.color)}
      onOtherClick={(color: ColorCMYK) => {
        setFieldValue('palletteColor', color)
      }}
    />
  )
}

export default FrameColors
